import { RUNTIME } from "../../runtime";
export async function chooseStreamWrapper(responseBody) {
    if (RUNTIME.type === "node" && RUNTIME.parsedVersion != null && RUNTIME.parsedVersion >= 18) {
        return new (await import("./Node18UniversalStreamWrapper")).Node18UniversalStreamWrapper(responseBody);
    }
    else if (RUNTIME.type !== "node" && typeof fetch === "function") {
        return new (await import("./UndiciStreamWrapper")).UndiciStreamWrapper(responseBody);
    }
    else {
        return new (await import("./NodePre18StreamWrapper")).NodePre18StreamWrapper(responseBody);
    }
}
